import {Injectable, OnDestroy} from '@angular/core';
import {
  fromEvent,
  merge,
  Observable,
  startWith,
  switchMap,
  timer,
  Subscription,
} from 'rxjs';

const ONE_HOUR_IN_MS = 60 * 60 * 1000;

@Injectable({
  providedIn: 'root',
})
export class UserInactivityService implements OnDestroy {
  private idleSub: Subscription | null;

  private get activityEvents(): Observable<Event> {
    return merge(
      fromEvent(document, 'mousemove'),
      fromEvent(document, 'keydown'),
      fromEvent(document, 'scroll'),
      fromEvent(document, 'click'),
    );
  }

  startMonitoring(
    onIdle: () => void,
    idleTimeMs: number = ONE_HOUR_IN_MS,
  ): void {
    this.stopMonitoring();

    this.idleSub = this.activityEvents
      .pipe(
        startWith(null), // triggers initial timer immediately
        switchMap(() => timer(idleTimeMs)), // reset timer on any activity
      )
      .subscribe(onIdle);
  }

  stopMonitoring(): void {
    this.idleSub?.unsubscribe();
    this.idleSub = null;
  }

  ngOnDestroy(): void {
    this.stopMonitoring();
  }
}
